import classNames from 'classnames';
import { FullPost } from 'model';
import { useState } from 'react';
import { PostItem } from './PostItem';
import { IconEyeOff } from './QuirkIcons';

import styles from './PostListItem.module.css';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../styles/Shared.module.css';

const ScreenAction: React.FC<{ setScreenRemoved: (val: boolean) => void }> = ({ setScreenRemoved }) => {
	const removeScreen = () => {
		setScreenRemoved(false);
	};

	return (
		<>
			<div className={styles.screenRemove} onClick={removeScreen}>
				<div>
					<IconEyeOff size="xlarge" />
				</div>
				<div>This content has been reported as sensitive.</div>
				<div className={sharedStyles.pill}>Show content</div>
			</div>
		</>
	);
};

export const PostListItem: React.FC<{ post: FullPost; detail?: boolean; expanded?: boolean }> = ({
	post,
	detail,
	expanded
}) => {
	const [screened, setScreenRemoved] = useState(post.totalReports > 2);

	return (
		<div className={styles.postOuterContainer}>
			<>
				{screened && <ScreenAction setScreenRemoved={setScreenRemoved} />}
				<div className={classNames([styles.minHeight, styles.feedItem])}>
					<PostItem post={post} detail={detail} expanded={expanded} screened={screened} />
				</div>
			</>
		</div>
	);
};
